import React from 'react';
import { Navigate } from 'react-router-dom';
import { isIslandCapabilityEnabled } from 'alakai-aloha-shared';
import { getRuntimeSiteContext } from '../../lib/siteContext';
import { hasInternalPlannerAccess } from '../../utils/internalPlannerAccess';

export default function IslandCapabilityRoute({
  children,
  capability,
  fallbackTo = '/coming-soon',
}) {
  const siteContext = React.useMemo(() => getRuntimeSiteContext(), []);

  if (
    !capability ||
    isIslandCapabilityEnabled(siteContext.island, capability) ||
    hasInternalPlannerAccess(capability, siteContext.island)
  ) {
    return children;
  }

  return <Navigate to={fallbackTo} replace />;
}
